import { INTERROGATOR_LIST, INTERROGATOR_LIST_SUCCESS, INTERROGATOR_LIST_ERROR } from './constants';
import { INTERROGATOR_DETAILS, INTERROGATOR_DETAILS_SUCCESS, INTERROGATOR_DETAILS_ERROR } from './constants';
import { ADD_INTERROGATOR_DETAILS, ADD_INTERROGATOR_DETAILS_SUCCESS, ADD_INTERROGATOR_DETAILS_ERROR } from './constants';
import { UPDATE_INTERROGATOR, UPDATE_INTERROGATOR_SUCCESS, UPDATE_INTERROGATOR_ERROR } from './constants';
import { DELETE_INTERROGATOR, DELETE_INTERROGATOR_SUCCESS, DELETE_INTERROGATOR_ERROR } from './constants';

export default function interrogatorReducer(state, action) {
	let interrogators = [];

	switch (action.type) {
	case INTERROGATOR_LIST:
		return { ...state, pending: true };
      
	case INTERROGATOR_LIST_SUCCESS:
        
		if (action.payload && action.payload.length > 0) {
			action.payload.map( (item) => {
            
				let data = {};

				data.id = item.id ? item.id : 0;
				data.manufacturer = item.manufacturer ? item.manufacturer : '';
				data.model = item.model ? item.model : '';
				data.version = item.version ? item.version : '';
				// data.createdAt = item.createdAt ? `${updatedAt.localdate} ${updatedAt.localtime}`  : '';
				// data.updatedAt = item.updatedAt ? item.updatedAt : '';

				return interrogators.push(data);
			});
          
			return { ...state, interrogators: interrogators, pending: false, error: false };
		} else {
			if (action.payload && action.payload.length === 0) {
				return { ...state, interrogators: interrogators, pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}
      
	case INTERROGATOR_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case INTERROGATOR_DETAILS:
		return { ...state, pending: true };

	case INTERROGATOR_DETAILS_SUCCESS:
		return { ...state, details: action.payload, pending: false, error: false };

	case INTERROGATOR_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case ADD_INTERROGATOR_DETAILS:
		return { ...state, pending: false };

	case ADD_INTERROGATOR_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case ADD_INTERROGATOR_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case UPDATE_INTERROGATOR:
		return { ...state, pending: false };

	case UPDATE_INTERROGATOR_SUCCESS:
		return { ...state, pending: false, error: false };

	case UPDATE_INTERROGATOR_ERROR:
		return { ...state, pending: false, error: true };
      
	case DELETE_INTERROGATOR:
		return { ...state, pending: false };

	case DELETE_INTERROGATOR_SUCCESS:
		return { ...state, pending: false, error: false };

	case DELETE_INTERROGATOR_ERROR:
		return { ...state, pending: false, error: true };

	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}